import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ConfigCtx = createContext({ settings: {}, pages: [], simulation: false, theme: "dark", setTheme: () => {} });

export function ConfigProvider({ children }) {
  const [cfg, setCfg] = useState({ settings: {}, pages: [], simulation: false });
  const [theme, setThemeState] = useState(() => localStorage.getItem("mr-theme") || "dark");

  useEffect(() => {
    api.get("/public/config").then(({ data }) => setCfg(data)).catch(() => {});
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("light", theme === "light");
    root.classList.toggle("dark", theme !== "light");
    const s = cfg.settings;
    const accent = theme === "light" ? s["brand.accent_light"] : s["brand.accent_dark"];
    const hover = theme === "light" ? s["brand.accent_hover_light"] : s["brand.accent_hover_dark"];
    if (accent) root.style.setProperty("--mr-accent", accent);
    else root.style.removeProperty("--mr-accent");
    if (hover) root.style.setProperty("--mr-accent-hover", hover);
    else root.style.removeProperty("--mr-accent-hover");
    document.querySelector('meta[name="theme-color"]')?.setAttribute("content", theme === "light" ? "#FFFFFF" : "#1C1C1C");
    if (s["brand.favicon_url"]) {
      document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]').forEach((l) => l.setAttribute("href", s["brand.favicon_url"]));
    }
    if (s["brand.pwa_icon_url"]) document.querySelector('link[rel="apple-touch-icon"]')?.setAttribute("href", s["brand.pwa_icon_url"]);
  }, [theme, cfg.settings]);

  const setTheme = (t) => {
    localStorage.setItem("mr-theme", t);
    setThemeState(t);
  };

  return <ConfigCtx.Provider value={{ ...cfg, theme, setTheme }}>{children}</ConfigCtx.Provider>;
}

export const useConfig = () => useContext(ConfigCtx);
